import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, DropdownButton, MenuItem, HelpBlock } from 'react-bootstrap';
import { Input, FormActions, DateTimeInput, Select } from '../../common/components/formControls';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import utils from '../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onSubmit, onReset, initialize, loading, paymentStatusTypes, paymentMethods, paymentCategories, enableManualInstalment,
	isSubscriptionComplianceEnabled, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	const menuItemInnerStyle = { display: 'block', padding: '10px 20px' };

	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='parent' component={Input} type='text' label={t('PaymentHistory_Parent')} />
						</Col>
						<Col sm={6}>
							<Field name='child' component={Input} type='text' label={t('PaymentHistory_Child')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='id' component={Input} type='text' label={t('PaymentHistory_Id')} />
						</Col>
						<Col sm={3}>
							<Field name='paymentDateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} label={t('PaymentHistory_PaymentDate')} placeholder={t('Common_From')} />
						</Col>
						<Col sm={3}>
							<Field name='paymentDateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('PaymentHistory_Center')} />
						</Col>
						<Col sm={6}>
							<Select name='status' label={t('PaymentHistory_Status')} data={paymentStatusTypes} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Select name='category' label={t('PaymentHistory_Category')} data={paymentCategories && paymentCategories.map(x => ({...x, displayName: t(`PaymentCategory_${x.name}`)}))} />
						</Col>
						<Col sm={6}>
							<Select name='paymentMethodId' label={t('PaymentHistory_PaymentMethod')} data={paymentMethods} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='isPaymentError' component={Input} componentClass='select' label={t('PaymentHistory_IsPaymentError')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
						<Col sm={6}>
							<Field name='isInactive' component={Input} componentClass='select' label={t('PaymentHistory_IsInactive')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='hasOutstandingAmount' component={Input} componentClass='select' label={t('PaymentHistory_HasOutstandingAmount')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
						{isSubscriptionComplianceEnabled && <Col sm={6}>
							<Field name='hasCancellationRequested' component={Input} componentClass='select' label={t('PaymentHistory_Subscription_CancellationRequested')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>}
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }, true))} disabled={loading} bsStyle='warning'>{t('Common_ExportToExcel')}</Button>

						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'paymentsFilter' })(withTranslation()(Filter));